import React, { createContext, useContext, useState, useEffect } from 'react'
import { BrowserRouter, Route, Routes, Link, useLocation } from 'react-router-dom'
import AOS from 'aos'
import 'aos/dist/aos.css'
import BasicExample from './Components/Header/Navbar'
import Home from './Components/Header/Main_Components/Home'
import Subcomponents from './Components/Header/Main_Components/Subcomponents'
import Inside from './Components/Header/Main_Components/Inside'
import Sideform from './Components/Sideform'
import Offers from './Components/Offers'
import About from './Components/About'
import Services from './Components/Services'
import Offersmain from './Components/Offersmain'
import Contact from './Components/Contact'
import LocationsPage from './Components/Locations/LocationsPage'
import Gallery from './Components/Gallery'

export const store = createContext()

function AosWatcher() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => {
      AOS.refresh();
    }, 150);
    return () => clearTimeout(timer);
  }, [location.pathname]);
  return null;
}




const MyContext = createContext();

export const useMyContext = () => {
  return useContext(MyContext);
};


function App() {

  // const[data,setData]=useState()
  // const[slugdata,setSlugData]=useState()

  const data = {
    "data": [

      {
        "navbar": {
          "brand": "/Images/logo/foton-logo-black.png",
          "menus": [
            { "label": "about us", "slug": "about", "arabic": "arabic" },
            {
              "label": "vechile", "sub_menus": [
                { "label": "Medium & Heavy Duty Trucks", "slug_name": "/Medium", "slug": "Medium", "id": 1 },
                { "label": "Light Duty Trucks", "slug_name": "light", "slug": "/light", "id": 2 },
                { "label": "Van & Pickup", "slug_name": "van", "slug": "/van", "id": 2 },
                { "label": "Special Vehicles", "slug_name": "special", "slug": "/special", "id": 2 }
              ]
            },
            { "label": "services", "slug": "service" },
            { "label": "offers", "slug": "offers" },
            { "label": "contact us", "slug": "contact" }
          ]

        }
      },


      {
        "banners": [
          { "image": "/Images/Banners/MicrosoftTeams-image (9).png" },
          { "image": "/Images/Banners/MicrosoftTeams-image (10).png" },
          { "image": "/Images/Banners/MicrosoftTeams-image (7).png" },
          { "image": "/Images/Banners/four.jpg" }


        ]
      },
      {
        "Products":
        {
          "heading": " Foton Products", "sub_heading": "With all series Commercial Vehicle business, Foton Motor is one of the leading Commercial Vehicle manufactures in the world.",
          "Vehicles_info": [
            { "image": "/Images/Card-img/AUMAN-EST-A-ICON.webp", "title": "Medium & Heavy Duty Trucks", "desc": "AUMAN, a wide range choices covering medium and long haul transportation and infrastructure" },
            { "image": "/Images/Card-img/AUMARK-S-ICON.webp", "title": "Light Duty Trucks", "desc": "AUMARK, urban transportation expert with European standard" },
            { "image": "/Images/Card-img/TUNLAND-ICON0.webp", "title": "Van & Pickup", "desc": "Pickup and Van for lifestyle and business" },
            { "image": "/Images/Card-img/sp.png", "title": "Special Vehicles", "desc": "Fossile and New Energy solutions tailored to your needs" }

          ]
        }


      },
      {
        "Vehicle": [
          { "Medium": { "heading": "Medium & Heavy Duty Trucks" } },


          { "light": { "heading": "Light Duty Trucks" } }
        ]

      }



    ]
  }


  const [lang, setLang] = useState(false)
  const [menu, SetMenu] = useState()

  const [slugdata, SetslugData] = useState()

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 50,
      delay: 50
    });
  }, []);

  return (
    <>
      {data &&
        <store.Provider value={[lang, setLang, menu, SetMenu, slugdata, SetslugData]}>
          <BrowserRouter>
            <AosWatcher />
            <BasicExample />
            {/* <NavScrollExample/> */}

            <ul id="MiniLeftNav">
              <li>
                <Link to={'/side'}>
                  <div className='rotating-image-div'>
                    <img className='rotating-image' src="/Images/logo/steering-wheel-icon-template-black-color-editable-steering-wheel-icon-symbol-flat-illustration-for-graphic-and-web-design-free-vect.png" alt="Book a Test Drive" width="50px" height="50px" />
                  </div>
                  <span>Book a Text Drive</span>
                </Link>
              </li>
            </ul>


            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/services' element={<Services />} />
              <Route path='/side' element={<Sideform />} />
              <Route path='/offer' element={<Offers />} />
              <Route path='/vehicles' element={<Subcomponents />} />
              <Route path='/vehicles/:slug' element={<Subcomponents />} />
              <Route path='/vechile-details/:slug' element={<Inside/>} />
              <Route path='/vehicle-details/:slug' element={<Inside/>} />
              <Route path='/about-us' element={<About/>}/>
              <Route path='/about-foton' element={<About/>}/>
              <Route path='/about-ggs' element={<About/>}/>
              <Route path='/offers' element={<Offersmain/>}/>
              <Route path='/contact-us' element={<Contact/>}/>
              <Route path='/gallery' element={<Gallery />} />
              <Route path='/gallery/:slug' element={<Gallery />} />
              <Route path='/book-a-test-drive' element={<Sideform />} />
              <Route path='/request-brochure' element={<Sideform />} />
              <Route path='/request-a-quote' element={<Sideform />} />
              <Route path='/show-rooms' element={<LocationsPage type="showroom" />} />
              <Route path='/showrooms' element={<LocationsPage type="showroom" />} />
              <Route path='/service-centers' element={<LocationsPage type="service" />} />
              <Route path='/services-centers' element={<LocationsPage type="service" />} />
            </Routes>
          </BrowserRouter>
        </store.Provider>
      }
    </>
  )
}

export default App
